// export const api: string = 'https://localhost:7254/api/';
// export const api: string = 'https://ft-web-api-container-app.yellowfield-bf8eac1a.canadaeast.azurecontainerapps.io/api/';
export const api: string = 'https://api.fillware.com/api/';
export const apiAuthentication: string = 'authentication/';
export const apiAccounts: string = 'accounts/';
export const apiPharmacies: string = 'pharmacies/';
export const apiEvents: string = 'events/';
export const apiPatients: string = 'patients/';
export const apiDoctors: string = 'doctors/';
export const apiPrescriptions: string = 'prescriptions/';

export const pharmaciesBaseRoute: string = '/pharmacies';
export const dashboardBaseRoute: string = '/dashboard';
export const calendarBaseRoute: string = '/calendar';
export const patientsBaseRoute: string = '/patients';
export const doctorsBaseRoute: string = '/doctors';
export const tokenKey: string = 'TOKEN';
export const currentPharmacyKey: string = 'X_PHARMACY_CODE';

export const genderOptions = [
  {
    value: 'M',
    label: 'Male'
  },
  {
    value: 'F',
    label: 'Female'
  },
  {
    value: 'U',
    label: 'Other'
  },
  {
    value: '',
    label: 'Leave Empty'
  }
];

export interface ILoginRequest {
  login: string;
  password: string;
}

export interface ILoginResponse {
  token: string;
  error: string;
}

export interface IAccount {
  id: number;
  name: string;
  email: string;
}

export interface IPharmacy {
  id: number;
  subscriptionCode: string;
  name: string;
  address: string;
  city: string;
  state: string;
  postalCode: string;
  phone: string;
  email: string;
  accountId: number;
  isAccountDefault: boolean;
}

export interface IEvent {
  id: number; 
  subject: string;
  location: string; 
  description: string;
  startDateTime: Date;
  endDateTime: Date;
}

export interface IPatientSearchRequest {
  personalHealthNumber: string | null;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  phone: string | null;
  dateOfBirth: Date | null;
}

export interface IDoctorSearchRequest {
  firstName: string | null;
  lastName: string | null;
  licenceNumber: string | null;
  email: string | null;
}

export interface IPrescriptionSearchRequest {
  startDate: Date | null;
  endDate: Date | null;
}

export interface IPatient {
  id: number;
  personalHealthNumber: string;
  firstName: string;
  lastName: string; 
  gender: string;
  dateOfBirth: Date;
  addressLine1: string;
  addressLine2: string;
  city: string; 
  province: string;
  postal: string;
  email: string;
  homePhone: string;
  mobilePhone: string;
  workPhone: string;
  dateOfFirstPrescription: Date;
  dateOfLastPrescription: Date;
  showUpFrequency: string;
}

export interface IDoctor {
  id: number;
  firstName: string;
  lastName: string; 
  licenceNumber: string;
  licenceReference: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  province: string;
  postal: string;
  email: string;
}

export interface IPrescription {
  id: number;
  rxNumber: string;
  rxDate: Date;
  patientId: number; 
  doctorId: number;
  din: string;
  dinName: string;
  status: string;
  quantityAuthorized: number;
  quantityDispensed: number;
  quantityRemaining: number;
  price: number;
  patient: IPatient; 
  doctor: IDoctor;
}